var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.isLoading
        ? _c("span", {
            staticClass: "fa fa-spinner fa-spin text-center",
            staticStyle: {
              "font-size": "60px",
              display: "block",
              margin: "auto",
            },
          })
        : _vm.error
        ? _c("div", { staticClass: "text-center" }, [
            _c("h3", { staticClass: "text-danger" }, [
              _c("em", [_vm._v(_vm._s(_vm.error.message))]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-default",
                attrs: { type: "button" },
                on: { click: _vm.fetch },
              },
              [_vm._v("Retry")]
            ),
          ])
        : !_vm.isEnabled
        ? _c("h4", { staticClass: "text-muted text-center" }, [
            _c("em", [
              _vm._v("No statistics have been configured for this corpus."),
            ]),
          ])
        : [
            _vm.statisticsTableData
              ? _c(
                  "div",
                  {
                    class: {
                      "col-xs-12": true,
                      "col-md-6": !!_vm.statisticsTableData,
                    },
                  },
                  [
                    _c(
                      "table",
                      {
                        staticClass: "table",
                        staticStyle: { "table-layout": "auto", width: "100%" },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.statisticsTableData,
                            function (value, key) {
                              return _c("tr", { key: key }, [
                                _c("td", [_c("strong", [_vm._v(_vm._s(key))])]),
                                _c("td", [_vm._v(_vm._s(value))]),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.snippet && _vm.distributionData
              ? _c(
                  "AnnotationDistributions",
                  _vm._b(
                    {
                      class: {
                        "col-xs-12": true,
                        "col-md-6": !!_vm.statisticsTableData,
                      },
                      attrs: { snippet: _vm.snippet },
                    },
                    "AnnotationDistributions",
                    _vm.distributionData,
                    false
                  )
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.snippet && _vm.growthData
              ? _c(
                  "AnnotationGrowths",
                  _vm._b(
                    {
                      staticClass: "col-xs-12",
                      attrs: { snippet: _vm.snippet },
                    },
                    "AnnotationGrowths",
                    _vm.growthData,
                    false
                  )
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center", attrs: { colspan: "2" } }, [
          _vm._v("Document Statistics"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }